import commonWords from './commonWords.esm.js';
import firstnames from './firstnames.esm.js';
import lastnames from './lastnames.esm.js';
import wikipedia from './wikipedia.esm.js';
import translations from './translations.esm.js';

const userInputs = [];
var index = {
  dictionary: {
    userInputs,
    commonWords,
    firstnames,
    lastnames,
    wikipedia
  },
  translations
};

export default index;
//# sourceMappingURL=index.esm.js.map
